const Menu = [
    {
    title: 'Introducir matrícula/bastidor',
    group: 'main',
    icon: 'mdi-magnify-scan',
    name: 'Escaneo',
    excludeRoles: ['admin'],
    hint: 'Escaneo de matriculas'
  },
  {
    title: 'Vehículos',
    group: 'main',
    icon: 'mdi-car-convertible',
    name: 'Vehiculo',
    excludeRoles: ['admin'],
    hint: 'Controle la gestión de vehiculos'
  },
  {
    title: 'Movimientos',
    group: 'main',
    icon: 'mdi-car-arrow-right',
    name: 'Movimiento',
    excludeRoles: ['admin'],
    hint: 'Controle la gestión de los movimientos'
  },
  {
    title: 'Cesiones',
    group: 'main',
    icon: 'mdi-swap-horizontal',
    name: 'Cesión',
    excludeRoles: ['admin'],
    hint: 'Controle la gestion de las cesiones'
  },
  {
    title: 'Notificaciones',
    group: 'main',
    icon: 'mdi-bell',
    name: 'Notificaciones',
    excludeRoles: ['admin'],
    hint: 'Controle la gestión de las notificaciones'
  },
  {
    title: 'Usuarios',
    group: 'main',
    icon: 'mdi-account-group',
    name: 'User',
    roles: ['manage_users', 'actualizar_usuario', 'agregar_usuario_normal', 'eliminar_usuario'],
    hint: 'Controle el acceso al sistema y sus funcionalidades'
  },
  {
    title: 'Grúas',
    group: 'main',
    icon: 'mdi-tow-truck',
    name: 'Grua',
    roles: ['crear_grua', 'editar_grua'],
    hint: 'Controle el acceso al sistema y sus funcionalidades'
  },
  {
    title: 'Conductores',
    group: 'main',
    icon: 'mdi-account-tie',
    name: 'Driver',
    roles: ['crear_conductor', 'editar_conductor'],
    hint: 'Controle la gestion de los conductores'
  },
  {
    title: 'Ubicaciones',
    group: 'main',
    icon: 'mdi-map-marker',
    name: 'Ubicacion',
    roles: ['crear_ubicacion', 'editar_ubicacion', 'eliminar_ubicacion'],
    hint: 'Controle la gestión de las ubicaciones'
  },
  {
    title: 'Reportes',
    group: 'main',
    icon: 'mdi-file-chart-outline',
    name: 'Reportes',
    roles: ['ver_reports'],
    hint: 'Consulte y descargue los reportes del sistema',
    items: [
      { name: 'Reporte1', title: 'Movimientos pendientes y antigüedad', icon: 'mdi-clock-alert-outline' },
      { name: 'Reporte2', title: 'Uso real de la herramienta', icon: 'mdi-account-check-outline' },
      { name: 'Reporte3', title: 'Cesiones y comodatos', icon: 'mdi-file-sign' },
      { name: 'Reporte4', title: 'Stock inmovilizado', icon: 'mdi-warehouse' },
      { name: 'Reporte5', title: 'Daños detectados', icon: 'mdi-car-crash' },
      { name: 'Reporte6', title: 'Vehículos pendientes de llegada', icon: 'mdi-truck-delivery-outline' }
    ]
  },
  {
    title: 'Configuración',
    group: 'main',
    icon: 'mdi-cog',
    name: 'Configuracion',
    hint: 'Ajustes del sistema'
  },
  {
    title: 'Asistente Virtual',
    group: 'main',
    icon: 'mdi-robot-outline',
    isChatbot: true,
    hint: 'Chatbot con IA de asistencia'
  }
]

export default Menu
